export default __webpack_public_path__ + "static/21-483f005f2bc425a7747dda409f30619e.png";